/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuprSendJwtTokenRequest
 */
export interface SuprSendJwtTokenRequest {
    /**
     * User ID for the JWT token
     * @type {string}
     * @memberof SuprSendJwtTokenRequest
     */
    user_id: string;
    /**
     * Tenant ID for the JWT token scope
     * @type {string}
     * @memberof SuprSendJwtTokenRequest
     */
    tenant_id?: string;
    /**
     * Token expiration time in seconds
     * @type {number}
     * @memberof SuprSendJwtTokenRequest
     */
    expires_in?: number;
}

/**
 * Check if a given object implements the SuprSendJwtTokenRequest interface.
 */
export function instanceOfSuprSendJwtTokenRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;

    return isInstance;
}

export function SuprSendJwtTokenRequestFromJSON(json: any): SuprSendJwtTokenRequest {
    return SuprSendJwtTokenRequestFromJSONTyped(json, false);
}

export function SuprSendJwtTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuprSendJwtTokenRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'expires_in': !exists(json, 'expires_in') ? undefined : json['expires_in'],
    };
}

export function SuprSendJwtTokenRequestToJSON(value?: SuprSendJwtTokenRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'tenant_id': value.tenant_id,
        'expires_in': value.expires_in,
    };
}

